import React from 'react';
import { Helmet, HelmetProvider } from 'react-helmet-async';
import styled from 'styled-components';
import '../../App.css';
import Aside from '../Aside';
import Footer from '../Footer';
import Header from '../Header';
import Links from '../links';


const Wrapper = styled.div`
  display: flex;
  flex-direction: row;
  max-width: 960px;
  margin: 20px auto;

  @media (max-width: 767px) {
    flex-direction: column;
    min-height: calc(100vh - 100px); /* 100pxはHeaderとFooterの高さ */
  }
`;

const Main = styled.main`
  flex: 1;
  padding: 10px;
  margin: 20px;
  background-color: #cdffff;
  box-shadow: 0px 0px 10px rgba(0, 0, 0, 0.1);

  @media (max-width: 767px) {
    // width: 100%;
    padding: 10px;
    margin: 0;
  }
`;

const MainContent = styled.div`
  // flex: 1;
  margin-bottom: 30px;

`;

// const Links = [
//   { url: '/posts', text: '掲示板' },
//   { url: '/events', text: 'イベント' },
// ]

function Base(props) {
  return (
    <>
      <MainContent>
        <HelmetProvider>
          <Helmet defaultTitle='プロスピA'>
            <title>{props.title}</title>
            <meta charSet="utf-8" />
          </Helmet>
        </HelmetProvider>
        <Header />
        <Wrapper>
          <Aside links={Links} />
          <Main>
            {props.body}
          </Main>
        </Wrapper>
        <Footer />
      </MainContent>
    </>
  );
}

export default Base;
